const AGENT_BASE = process.env.NODE_ENV === 'development' ? '/agent-api' : 'https://agent-api-dev.flexigo.com';

export const agent = {
  workflows: `${AGENT_BASE}/v1/workflows`,
  workflow: (workflowId) => `${AGENT_BASE}/v1/workflows/${workflowId}`,
  sessions: `${AGENT_BASE}/v1/sessions`,
  session: (sessionId) => `${AGENT_BASE}/v1/sessions/${sessionId}`,
  userInput: (sessionId) => `${AGENT_BASE}/v1/sessions/${sessionId}/user_input`,
  tokenMessages: (sessionId, tokenId) => `${AGENT_BASE}/v1/sessions/${sessionId}/tokens/${tokenId}/messages`,
};

export default agent;
